import React from 'react';

import { useInView } from '../../hooks/useInView';
import type { CareersPitch } from './types';

export function CareersPitchSection({ data }: { data: CareersPitch }) {
    const [ref, inView] = useInView<HTMLElement>();

    return (
        <section
            ref={ref}
            className={`careers-pitch faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
        >
            <h2 className="careers-pitch__heading faves-display faves-reveal">{data.heading}</h2>
            <div className="careers-pitch__body">
                {data.body.map((paragraph, i) => (
                    <p
                        key={i}
                        className="careers-pitch__paragraph faves-body faves-reveal"
                        style={{ '--reveal-delay': `${160 + i * 120}ms` } as React.CSSProperties}
                    >
                        {paragraph}
                    </p>
                ))}
            </div>
        </section>
    );
}
